module.exports = __webpack_public_path__ + "static/media/error.ea17fa3f.svg";